import {
  postRequest,
  patchRequest,
  postFormDataRequest,
  getRequest,
  deleteRequest
} from "../lib/utils/request";

export const createAPI = async (apiHost, data, requestOptions) => {
  return await postRequest(`${apiHost}/v1/newsletter`, data, requestOptions);
};



/** WEBPACK FOOTER **
 ** ./src/common/newsletter/api.js
 **/